export default __webpack_public_path__ + "static/media/Wallet.42a4ce33.svg";